import { PasswordStrength } from '@components/PasswordStrength'
import styled from '@emotion/styled'
import { Box, Divider, Tab as MuiTab, Typography } from '@mui/material'

const DescriptionText = styled(Box)`
	${({ theme }) => `
		font-size: 14px;
		color: ${theme.palette.text.secondary};
	`}
`

const Logo = styled.img`
	max-height: 50px;
	margin-bottom: 24px;
`

const StyledPasswordStrength = styled(PasswordStrength)`
	overflow: hidden;
	transition: max-height 0.15s ease-out;
	max-height: ${(props: { collapsed: boolean }) =>
		props.collapsed ? '0' : '250px'};
`

const SupportLink = styled(Typography)`
	${({ theme }) => `
		cursor: pointer;
		display: inline;
		text-decoration: underline;
		color: ${theme.palette.fonts.green};
	`}
`

const StyledDivider = styled(Divider)`
	${({ theme }) => `
		background: ${theme.palette.divider};
	`}
`

const Tab = styled(MuiTab)`
	align-items: center !important;
`

export {
	DescriptionText,
	Logo,
	StyledDivider,
	StyledPasswordStrength,
	SupportLink,
	Tab,
}
